import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const title: CSSObject = {
  minWidth: 0,
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
  color: color.text,
  wordBreak: 'break-all',
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textSub,
};

export { title, meta };
